import api from "@api";
import getQueryString from "@tools/getQueryString";
import CopyProperty from "@tools/CopyProperty";
export default {
    data() {
        return {
            optType: "add",
            formId: "",
        }
    },
    mounted() {
        this.init();
    },

    methods: {
        init() {
            let typeId = getQueryString("typeId");
            // console.log(typeId);
            typeId && (this.formConfig.typeId = typeId - 0);
            let formId = getQueryString("id");
            let optType = getQueryString("optType");
            if (formId) {
                this.formId = formId;
                this.optType = optType || "edit";
                this.$successAjax(api.formInfo + "/" + this.formId, {}, {
                    method: "get"
                }).then(({ data }) => {
                    const { config, list } = data;
                    if (this.optType == "copy") {
                        config.formName = "";
                        config.enName = "";
                        config.isPushData = "2";
                    };
                    CopyProperty(this.formConf, config);
                    list.forEach((item) => {
                        if (item["show-word-limit"]) {
                            if (typeof item["show-word-limit"] == "string") {
                                item["show-word-limit"] = (item["show-word-limit"] == "true" ? true : false)
                            }
                        };
                        if (item["compType"] === "rate" || item["compType"] === "slider") {

                            item["value"] = item["value"] - 0;
                        }
                        this.list.push(item);
                    });
                });
            };
        },
        tapSave() { //点击保存
            try {
                this.validate();
                let config = JSON.parse(JSON.stringify(this.formConf));
                let list = JSON.parse(JSON.stringify(this.list));

                let param = {
                    config,
                    list
                };
                let url = api.formInfo;
                if (this.optType == "edit") {
                    param.id = this.formId;
                    url = api.editFormInfo;
                };
                console.log(param)
                this.$successAjax(url, param).then(() => {
                    this.$message.success("操作成功");
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 2000);
                });
            } catch (error) {
                // console.log(error);
                this.$message.error(error.message);
            }
        },
        validate() {//校验
            this.validateFormConfig();
            this.validateFieldConfig();
            return true;
        },
        validateFormConfig() {  //校验表单配置
            let formConf = this.formConf;
            if (formConf.formName.trim() == "") {
                throw new Error("表单名称不能为空");
            };
            if (formConf.typeId == "") {
                throw new Error("请选择表单分类");
            };
        },
        validateFieldConfig() {//校验表单字段配置
            this.list.forEach((ele, index) => {
                if (!ele.id || (ele.id.trim() == "")) {
                    throw new Error(`第${index + 1}项的ID为空`);
                };
                if (ele.compType == "dynamicTable") {
                    if (!ele.columns || ele.columns.length == 0) {
                        throw new Error(`第${index + 1}项的动态表格没有配置列`);
                    }
                }
            });

        },
    },

};